import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function Hero() {
  return (
    <section className="py-16 md:py-20 px-4 relative overflow-hidden">
      {/* Light Blue to White Gradient */}
      <div
        className="absolute inset-0 z-0"
        style={{
          background: "linear-gradient(to bottom, rgba(230, 240, 245, 0.8), rgba(255, 255, 255, 1))",
        }}
      ></div>

      <div className="container mx-auto flex flex-col md:flex-row items-center relative z-10">
        <div className="md:w-1/2 text-center md:text-left mb-10 md:mb-0">
          <motion.h1
            initial={{ y: -30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="text-3xl md:text-6xl font-bold text-gray-800 mb-4 md:mb-6 leading-tight"
          >
            Banking Simplified. <br className="hidden md:block" />
            Your Future Secured.
          </motion.h1>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.6, ease: "easeOut" }}
            className="text-base md:text-lg text-gray-700 mb-6 md:mb-8"
          >
            Experience the ease of accessible banking with Keziah, a trusted
            Business Correspondent of Fino Payments Bank. We empower you with
            innovative financial solutions tailored to your needs.
          </motion.p>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.6, ease: "easeOut" }}
          >
            <Link
              to="/Services"
              className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 md:py-4 px-6 md:px-8 rounded-full text-base md:text-lg transition duration-300 ease-in-out shadow-lg hover:shadow-xl"
            >
              Explore Services
            </Link>
          </motion.div>
        </div>

        {/* Image/Illustration (or Logo) */}
        <div className="md:w-1/2 flex justify-center mt-8 md:mt-0">
          <motion.img
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.6, ease: "easeOut" }}
            src="/assets/keziah.png" // Replace with a compelling illustration or your logo if you prefer
            alt="Financial Empowerment Illustration"
            className="w-full max-w-md md:max-w-lg"
          />
        </div>
      </div>
    </section>
  );
}

export default Hero;